import SectionBlock from 'components/SectionBlock'
import Slider from 'components/Slider'
import categoryUrl from 'helpers/categoryUrl'
import React, { Fragment } from 'react'

const ProductBlock = ({ block }) => {
  return (
    <Fragment>
      <SectionBlock
        id={block.id}
        title={block.name}
        linkText={block.link_text}
        link={block.slug ? categoryUrl(block.slug) : null}
        countdown={block.countdown}
      >
        <Slider
          type="product-items"
          productItems={block.products.products || []}
          settings={{
            arrows: true,
            rows: 1,
          }}
          progressBar
        />
      </SectionBlock>
    </Fragment>
  )
}

export default ProductBlock
